var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtensionsAmendments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.579 32.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "extension",
    transform: "translate(-0.75 -0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25023",
    "data-name": "Path 25023",
    d: "M12.706,5.261H2.064A1.064,1.064,0,0,0,1,6.325V16.967a1.064,1.064,0,0,0,1.064,1.064H12.706a1.064,1.064,0,0,0,1.064-1.064V6.325A1.064,1.064,0,0,0,12.706,5.261ZM11.641,15.9H3.128V7.389h8.513ZM32.688,8.765,25.163,1.241a1.064,1.064,0,0,0-1.5,0L16.134,8.765a1.064,1.064,0,0,0,0,1.5l7.525,7.525a1.064,1.064,0,0,0,1.5,0l7.525-7.525a1.064,1.064,0,0,0,0-1.5Zm-8.277,6.772-6.02-6.02,6.02-6.02,6.02,6.02ZM12.706,20.159H2.064A1.064,1.064,0,0,0,1,21.223V31.865a1.064,1.064,0,0,0,1.064,1.064H12.706a1.064,1.064,0,0,0,1.064-1.064V21.223A1.064,1.064,0,0,0,12.706,20.159ZM11.641,30.8H3.128V22.287h8.513ZM27.6,20.159H16.962A1.064,1.064,0,0,0,15.9,21.223V31.865a1.064,1.064,0,0,0,1.064,1.064H27.6a1.064,1.064,0,0,0,1.064-1.064V21.223A1.064,1.064,0,0,0,27.6,20.159ZM26.539,30.8H18.026V22.287h8.513Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionsAmendments);
export default __webpack_public_path__ + "static/media/ExtensionsAmendments.4cc0bdb040e77555b7275b620cc83061.svg";
export { ForwardRef as ReactComponent };